<fieldset>
  <div class="form-group" [class.row]="!detailViewComponent.smallScreen">
    <label class="col-form-label" [class.col-4]="!detailViewComponent.smallScreen"> </label>
    <div class="mb-sm-1" [class.col-8]="!detailViewComponent.smallScreen">
      <div class="input-group input-group-sm">
        <div class="form-control empty-field"></div>
      </div>
    </div>
  </div>
</fieldset>
